module.exports = __webpack_public_path__ + "static/img/about_zuzhi.6266545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_zuzhi.jpg
// module id = Rnpk
// module chunks = 12